import api from 'config/api.js';
import axios from 'axios';


export const loadAllSettings = async () => {
    try {
        const response = await axios.get(api.url + api.path.settings);

        return response.data;
    } catch (error) {
        return {
            isLogged: false,
            user: null,
            error: error.response.data,
        };
    }
};


